<template>
  <div class="form-course-item">
    <div v-if="column.label">{{ column.label }}:</div>

    <div :style="{color: style.color ? style.color : '#333'}" v-if="column.value">{{ column.value }}</div>
  </div>
</template>

<script>
export default {
  props: ['column'],
  data() {
    return {
      style: this.column.styles
    }
  }
}
</script>

<style lang="scss">
.form-course-item {
  margin: 10px;
  background: #ffffff;
  border-radius: 4px;
  padding: 10px;
  .form-item-title {
    font-weight: 700;
    color: #303133;
    font-size: 16px;
    margin-bottom: 10px;
  }
}
</style>
